import { Fragment, useMemo } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { FiCheck, FiChevronDown } from "react-icons/fi";

function InlineFilterSelect({ prefix = "Filter by", options = [], value = "", onChange = () => {}, className = "" }) {
	const selectedOption = useMemo(() => options.find((option) => option.value === value) || options[0] || {}, [options, value]);

	return (
		<Listbox
			as="div"
			value={selectedOption?.value}
			onChange={(nextValue) => {
				const nextOption = options.find((option) => option.value === nextValue);
				if (nextOption) onChange(nextOption);
			}}
			className={`relative ${className}`}
		>
			<Listbox.Button className="flex w-full items-center gap-2 rounded-md border border-surface bg-canvas px-3 py-2 text-xs text-secondary">
				<span className="whitespace-nowrap">{prefix}</span>
				<span className="min-w-0 flex-1 truncate text-left text-primary">{selectedOption?.label || ""}</span>
				<FiChevronDown className="h-3.5 w-3.5 shrink-0 text-primary" />
			</Listbox.Button>
			<Transition
				as={Fragment}
				enter="transition ease-out duration-100"
				enterFrom="opacity-0 scale-95"
				enterTo="opacity-100 scale-100"
				leave="transition ease-in duration-75"
				leaveFrom="opacity-100 scale-100"
				leaveTo="opacity-0 scale-95"
			>
				<Listbox.Options className="absolute left-0 top-full z-30 mt-1 max-h-60 w-full overflow-auto rounded-md border border-surface bg-canvas py-1 shadow-lg focus:outline-none">
					{options.map((option) => (
						<Listbox.Option key={option.value} value={option.value} as={Fragment}>
							{({ active, selected }) => (
								<li className={`flex cursor-pointer items-center justify-between px-3 py-2 text-sm ${active ? "bg-light" : "bg-canvas"} ${selected ? "text-primary" : "text-dark"}`}>
									<span className="truncate">{option.label}</span>
									{selected && <FiCheck className="ml-2 h-4 w-4 shrink-0" />}
								</li>
							)}
						</Listbox.Option>
					))}
				</Listbox.Options>
			</Transition>
		</Listbox>
	);
}

export default InlineFilterSelect;
